module.exports = __webpack_public_path__ + "img/logo-xbox.0a6ad33d.svg";